<template>
  <div v-if="user" class="">
    <preloader :is-visible="isLoading"></preloader>
    <div class="uk-width-1-2@m">
      <div class="uk-margin">
        <user-edit-card :user="user" :userLang="userLang" :role="role" @getUser="getProfile()"/>
      </div>
      <div class="uk-margin">
        <user-password-card :user="user"/>
      </div>
      <div class="uk-margin">
        <user-localization-card :user="user" @setUserLang="userLang = $event"/>
      </div>
    </div>
    <!--<div class="md-layout-item md-size-33 md-small-size-100">
      <user-profile-card :user="user"/>
    </div>-->
  </div>
</template>

<script>
  import UserEditCard from "@/pages/Dashboard/Examples/UserProfile/EditProfileCard.vue";
  import UserPasswordCard from "@/pages/Dashboard/Examples/UserProfile/EditPasswordCard.vue";
  import UserLocalizationCard from "@/pages/Dashboard/Examples/UserProfile/EditLocalizationCard.vue";
  import Preloader from "@/pages/Dashboard/Components/Preloader";

  export default {
    name: "user-profile-example",
    components: {
      Preloader,
      "user-edit-card": UserEditCard,
      "user-password-card": UserPasswordCard,
      "user-localization-card": UserLocalizationCard
    },
    data: () => ({
      isLoading: true,
      user: null,
      role: null,
      grecapthcaResult: true,
      getterKey:0,
      userLang: null
    }),
    created() {
      this.getProfile();
      setTimeout(()=>{
        this.isLoading = false;
      }, 3000)
    },
    methods: {
      async getProfile() {
        await this.$store.dispatch("profile/me", { includes: "worksheet,docs" });
        await this.$store.dispatch("profile/role");
        this.getterKey++;
        this.user = await this.$store.getters["profile/me"](this.getterKey);
        this.role = await this.$store.getters["profile/role"];
      }
    }
  }
</script>